import {combineReducers} from '@reduxjs/toolkit';
import {accessManagementUsersSlice} from 'src/modules/access-management/service/access-management-users.slice';
import {accessManagementSlice} from 'src/modules/access-management/service/access-management.slice';
import {userInfoSlice} from 'src/modules/main/services/user-info-slice';
import {requestsSlice} from 'src/modules/vendor-admin/service/requests.slice';

export const rootReducer = combineReducers({
    userInfo: userInfoSlice.reducer,
    accessManagementUsers: accessManagementUsersSlice.reducer,
    requestsReducer: requestsSlice.reducer,
    accessManagement: accessManagementSlice.reducer,
});
